import { ComparatorEnum } from '../../../models/interface/comparator.enum';
import { PermissionUserOption } from '../keys/permissionUser.interface';
import { PermissionBaseType } from '../models/permissionBaseType.enum';
import { PermissionOperator } from '../models/permissionOperator.interface';
import { PermissionOption } from '../models/permissionOption.interface';

export const PermissionUser: PermissionOption[] = [
  {
    code: 'P158',
    option: PermissionUserOption.USER_COMMON_LOGIN,
    permissions: ['settings.common.login'],
    comparator: ComparatorEnum.EXACT,
  },
  { code: 'P150', option: PermissionUserOption.USER_LIST, permissions: ['domi.users.list'] },
  {
    code: 'P152_153',
    option: PermissionUserOption.USER_ASSIGN_ROLE_AND_POINTS,
    permissions: ['domi.users.associate_points', 'domi.user.associateRole'],
    operator: PermissionOperator.OR,
  },
  { code: 'P151', option: PermissionUserOption.USER_CREATE, permissions: ['domi.users.create'] },
  { code: 'P151', option: PermissionUserOption.USER_ASSIGN_ROLE_AND_PERMISSIONS, permissions: ['domi.users.create'] },
  { code: 'P152', option: PermissionUserOption.USER_ASSIGN_POINT, permissions: ['domi.users.associate_points'] },
  { code: 'P152', option: PermissionUserOption.USER_REASSIGN_POINT, permissions: ['domi.users.associate_points'] },
  { code: 'P153', option: PermissionUserOption.USER_ACTIVE_ACTION, permissions: ['domi.user.activeAction'] },
  { code: 'P154', option: PermissionUserOption.USER_INACTIVE_ACTION, permissions: ['domi.user.inactiveAction'] },
  { code: 'P155', option: PermissionUserOption.USER_EDIT, permissions: ['domi.user.edit'] },
  { code: 'P156', option: PermissionUserOption.USER_DELETE, permissions: ['domi.user.delete'] },
  { code: 'P157', option: PermissionUserOption.USER_ASSIGN_ROLE, permissions: ['domi.user.associateRole'] },
  {
    type: PermissionBaseType.FLAG,
    code: 'FXXX',
    option: PermissionUserOption.USER_SOCKET_FRONT,
    permissions: ['activate_socket_front'],
  },
];
